module.exports = __webpack_public_path__ + "static/media/19.a5690a63.JPG";